module.exports = __webpack_public_path__ + "img/at.60c12463.svg";